// extracted by mini-css-extract-plugin
module.exports = {"howTo":"Howto_howTo__2oF8m","content":"Howto_content__2WDjL"};